import { ImageThumbnailRatio } from '@components/ImageThumbnailRatio';
import VnrLink from '@components/VnrLink';
import React from 'react';

import styles from "./LargePostItem.module.scss";

const PostItemMostView = ({ post }) => {

  const {title, date, excerpt, thumbnail, slug, author} = post;
  const publicDate = new Date(date);
  const formatDate = new Intl.DateTimeFormat('ru-RU', { dateStyle: 'short', timeStyle: 'short' }).format(publicDate);

  return (
    <div className={styles.vnrPostItemPageCategory}>
      <VnrLink 
        aria-label={slug}
        to={`${slug}.html`} 
        className={styles.postThumbnailPageCategory}
      >
        <ImageThumbnailRatio src={thumbnail?.url || thumbnail} alt="post-thumbnail" />
      </VnrLink>
      <div>
        <div>
          <span className={styles.postDetail}>{formatDate}</span>
          {author && 
            <VnrLink to={`/tac-gia/${author.slug}`}>
              <span className={styles.postDetail}> &#8226; {author.name}</span>
            </VnrLink>
          }
        </div>
        <VnrLink to={`${slug}.html`}>
          <h3 className={styles.postTitlePageCategory}>{title.rendered}</h3>
        </VnrLink>
        <div 
          dangerouslySetInnerHTML={{ __html: `${excerpt.rendered}` }}
          className={styles.postDescription}></div>
      </div>
    </div>
  )
}
export default PostItemMostView;